module.exports = __webpack_public_path__ + "img/is_pets_allowed.8cfbc74c.webp";